import { render } from "./BilanciPrevisionaliBu.vue?vue&type=template&id=d640e952&ts=true"
import script from "./BilanciPrevisionaliBu.vue?vue&type=script&lang=ts"
export * from "./BilanciPrevisionaliBu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__